export const ACCESSIBLE = window.gettext('accessible')
export const ACCOMMODATION = window.gettext('accommodation')
export const ACCOMMODATIONS = window.gettext('accommodations')
export const ACCOMMODATION_DESCRIPTION = (d) => window.interpolate(window.gettext("Discover the %(accommodation_type)s  %(accommodation_name)s in %(place_title)s on the %(route_title)s. You will find information about services, user reviews and contact details."), d, true)
export const ACCOMMODATION_ORDER = window.gettext('accommodation order')
export const ACTIONS = window.gettext('actions')
export const ADDRESS = window.gettext('address')
export const ADD_AT_TRAIL_END = window.gettext('Add at trail end')
export const ADD_AT_TRAIL_START = window.gettext('Add at trail start')
export const ADD_TO_FAVORITE = window.gettext('add to favorite')
export const ADD_TO_TRAIL = window.gettext('Add to trail')
export const AMENITIES = window.gettext('amenities')
export const APPLICATION_ERROR = window.gettext('Application Error')
export const APPLICATION_ERROR_MESSAGE = window.gettext('We track these errors automatically, but if the problem persists feel free to contact us. In the meantime, try refreshing.')
export const ARRIVE_IN = window.gettext('arrive in')
export const AVERAGE_PRICE = window.gettext('average prices')
export const BIG = window.gettext('big')
export const BOOK_A_ROOM = window.gettext('Book a room now!')
export const CAMPSITE = window.gettext('campiste')
export const CAMPSITES = window.gettext('campsites')
export const CHANGE_DATE = window.gettext('change date') 
export const CHEAPEST = window.gettext('cheapest')
export const CHECK_AVAILABILITY = window.gettext('check availability')
export const CHECK_AVAILABILITY_PRICE = window.gettext('check accommodation availability and price')
export const CHECK_IN_DATE = window.gettext('check-in date')
export const CONTACTS = window.gettext('contacts')
export const COST = window.gettext('cost')
export const DEVIATION_OF_TRAIL = window.gettext('deviation out of trail')
export const DIFFICULT =window.gettext('difficult')
export const DISABLED_FRIENDLY = window.gettext('disabled friendly rooms')
export const DISTANCE_FROM_TRAIL =window.gettext('distance from trail')
export const DOWNLOAD = window.gettext('download')
export const DOWNLOAD_GPX = window.gettext('download GPX')
export const DOWNLOAD_LINK = window.gettext('download link')
export const DOWNLOAD_PDF = window.gettext('download PDF')
export const DRINKING_WATER = window.gettext('fountain')
export const DRINKING_WATERS = window.gettext('fountains')
export const DURATION = window.gettext('duration')
export const EMAIL = window.gettext('e-mail')
export const ENABLE_GEOLOCATION = window.gettext('Please enable browser geolocation')
export const ERROR_ALERT = window.gettext('Fetching Error. Some contents are not available')
export const FAST_WALKING_PACE = window.gettext('fast walking speed') 
export const FONT_SIZE = window.gettext('font size')
export const FOOD_AND_DRINK = window.gettext('food and drink')
export const FOOD_FACILITY = window.gettext('food facility')
export const GEOLOCATION = window.gettext('geolocation')
export const GO_BACK = window.gettext('go back')
export const GO_TO_HOME_PAGE = window.gettext('go to home page')
export const GO_TO_PLACE = window.gettext('go to place')
export const GO_TO_STAGE = window.gettext('go to stage')
export const GUEST = window.gettext('guest')
export const GUESTS = window.gettext('guests')
export const GUEST_DETAILS = window.gettext('guest details')
export const HISTORIC = window.gettext('historic place')
export const HISTORICS = window.gettext('historic places')
export const IMPERIAL = window.gettext('imperial (ml/ft)') 
export const INFO = window.gettext('info')
export const KEEP_SCREEN_ACTIVE = window.gettext('keep screen active')
export const KITCHEN = window.gettext('kitchen')
export const LANGUAGE = window.gettext('Language')
export const LENGTH = window.gettext('length')
export const LOAD_MORE = window.gettext('load more')
export const LUXURY = window.gettext('luxury')
export const MEDIUM = window.gettext('medium')
export const MENU = window.gettext('menu')
export const MERGE_STAGE = window.gettext('Remove stop, merge the stages')
export const METRIC = window.gettext('metric (km/m)') 
export const NEXT_STAGE = window.gettext('next stage')
export const NIGTH = window.gettext('night')
export const NIGTHS = window.gettext('nights')
export const NORMAL_WALKING_PACE  = window.gettext('normal walking speed')
export const NO_ROOMS_AVAILABLE = window.gettext('No rooms available. Please change date')
export const OFFLINE_ALERT = window.gettext('You are offline. Some contents are not available')
export const ONLINE_BOOKABLE = window.gettext('online bookable')
export const OUT_OF_MAPS = window.gettext('geolocation is disabled because your current position is far from the trail')
export const OUT_OF_TRAIL = window.gettext('You are out of the trail!')
export const PAGE_NOT_FOUND = window.gettext('page not found')
export const PET = window.gettext('pet friendly')
export const PET_FRIENDLY = window.gettext('pet friendly rooms')
export const PHONE = window.gettext('phone')
export const PLACES_LIST = window.gettext('places list')
export const PLACE_DESCRIPTION = (d) => window.interpolate(window.gettext("Discover the %(place_type)s of %(place_name)s on the %(route_title)s. You will find information on services and accommodation, with maps, walking time and distances in km and miles."), d, true)
export const POSITION_RELATIVE_STATS = window.gettext('Distances and travel times are calculated based on your current position on the route')
export const POSITION_TIMEOUT = window.gettext('Position Timeout, please try again in 1 minute')
export const POSITION_UNAVAILABLE = window.gettext('Position unavailable')
export const PREVIEW_STAGE = window.gettext('preview stage')
export const PRICE_RANGE = window.gettext('price range')
export const RATING = window.gettext('rating')
export const READ_REVIEWS_ON_BOOKING = window.gettext('read reviews on Booking.com')
export const RELAXED_WALKING_PACE =window.gettext('relaxed walking speed') 
export const RELEVANCE = window.gettext('relevance')
export const RELOAD = window.gettext('reload')
export const REMOVE_FIRST_STAGE = window.gettext('Remove first stage')
export const REMOVE_FROM_FAVORITE = window.gettext('remove from favorite')
export const REMOVE_LAST_STAGE = window.gettext('Remove last stage')
export const REMOVE_START_POINT = window.gettext('Remove start point') 
export const REMOVE_STOP = window.gettext('Remove stop')
export const ROUTES_DESCRIPTION = (d) => window.interpolate(window.gettext("Discover the route %(route_title)s. Here you will find information on the stages, with a map, distance in km and miles, walking time and a complete list of hostels."), d, true)
export const ROUTES_LIST = window.gettext('routes list')
export const ROUTE_SHARE = window.gettext('share this route')
export const SET_STAGE_START = window.gettext('Set as stage start')
export const SET_STAGE_STOP = window.gettext('Set as stage stop')
export const SHELTER = window.gettext('shelter')
export const SHELTERS = window.gettext('shelters')
export const SHOP = window.gettext('shop')
export const SHOPS = window.gettext('shops')
export const SHOW_ALTERNATIVE_STOPS = window.gettext('show alternative stops')
export const SHOW_LESS = window.gettext('show less')
export const SHOW_MORE = window.gettext('show more') 
export const SHOW_ON_MAP = window.gettext('show on map')
export const SMALL = window.gettext('small')
export const SOMETHING_WENT_WRONG = window.gettext('something went wrong')
export const SORT = window.gettext('sort')
export const SPLIT_STAGE = window.gettext('Add a stop, split stage')
export const SPRING = window.gettext('natural spring')
export const SPRINGS = window.gettext('natural springs')
export const STAGE  = window.gettext('stage')
export const STAGES  =window.gettext('stages')
export const STAGES_LIST  =window.gettext('stage list')
export const STAGE_LIST = window.gettext('stage list')
export const START_FROM = window.gettext('start from')
export const TOURISM = window.gettext('tourist attraction')
export const TOURISMS = window.gettext('tourist attractions')
export const TRAIL_DURATION  = window.gettext('trail duration')
export const TRAIL_LENGTH = window.gettext('trail length')
export const TRAIL_STAGES_NUMBER = window.gettext('trail stages number')
export const TRAIL_TRAVEL_TIME = window.gettext('trail travel time')
export const UNITS_OF_MESURE = window.gettext('units of mesure')  
export const USER_RATING = window.gettext('user rating')
export const VIEW_ON_BOOKINGCOM = window.gettext('view on booking.com')
export const WAITING_POSITION = window.gettext('searching for your current location')
export const WALKING_PACE =window.gettext('walking pace') 
export const WEBSITE = window.gettext('website')
export const WHERE_TO_SLEEP=window.gettext('where to sleep')
export const WHERE_TO_SLEEP_DESCRIPTION = window.gettext('The list of the best accommodations, with photos, reviews and distances from the route. Find your favorite accommodation and book it directly online.')
export const WHERE_TO_SLEEP_IN = window.gettext('where to sleep in')
